import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUICustomizationPresetDTO } from "../../services/ui-customization-data-service/Models";
import UICustomizationDataService from "../../services/ui-customization-data-service/UICustomizationDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseUICustomizationPresetParameters = {
    groupID: number;
    presetID: number;
} & BaseUseQueryParameters<IUICustomizationPresetDTO>;

export function useUICustomizationPreset({
    groupID,
    presetID,
    enabled,
    onError,
    onSuccess
}: UseUICustomizationPresetParameters) {
    return useQuery<IUICustomizationPresetDTO, RestError, IUICustomizationPresetDTO>(
        keys.preset(presetID),

        ({ signal }) => {
            if (presetID > -1) {
                return UICustomizationDataService.getUICustomizationPreset(groupID, presetID, signal);
            } else {
                const defaultPreset: IUICustomizationPresetDTO = UICustomizationDataService.createDefaultUICustomizationPreset();
                return Promise.resolve(defaultPreset);
            }
        },
        {
            enabled,
            onError,
            onSuccess
        }
    );
}